import React, { useState, useRef, useCallback } from "react";
import Webcam from "react-webcam";
import * as Component from "../../component";

const FACING_MODE_USER = { facingMode: 'user' }; //Front Camera
const FACING_MODE_ENVIRONMENT = { facingMode: { exact: 'environment' } }; //Back Camera

const CameraComponent = ({ image, onChange }) => {
  const webcamRef = useRef(null);
  const [videoConstraints, setVideoConstraints] = useState(FACING_MODE_USER);
  const [modal, setModal] = useState(false);
  const [capturedImage, setCapturedImage] = useState(null);
  const [isCapturing, setIsCapturing] = useState(false);

  const getListOfVideoInputs = async () => {
    const mediaDevices = await navigator.mediaDevices.enumerateDevices();
    return mediaDevices.filter(device => device.kind === 'videoinput');
  }

  const switchCamera = async () => {
    const videoInpuList = await getListOfVideoInputs();
    if (videoInpuList.length > 1) {
      const currectVideoConstraints = { ...videoConstraints };

      if (JSON.stringify(currectVideoConstraints) === JSON.stringify(FACING_MODE_USER)) {
        setVideoConstraints(FACING_MODE_ENVIRONMENT);
      }
      if (JSON.stringify(currectVideoConstraints) === JSON.stringify(FACING_MODE_ENVIRONMENT)) {
        setVideoConstraints(FACING_MODE_USER);
      }
    } else {
      Component.AlertError({ text: 'Device have only one camera' })
    }
  };

  const base64ToFile = (base64, filename, mimeType) => {
    const arr = base64.split(',');
    const bstr = atob(arr[1]);
    let n = bstr.length;
    const u8arr = new Uint8Array(n);
    while (n--) {
      u8arr[n] = bstr.charCodeAt(n);
    }
    return new File([u8arr], filename, { type: mimeType });
  }

  const postStorageServer = async (file) => {
    const formData = new FormData();

    formData.append("file", file);
    formData.append("email", process.env.REACT_APP_EMAIL);
    formData.append("password", process.env.REACT_APP_PASSWORD);

    try {
      const res = await fetch(process.env.REACT_APP_URL_STORAGE, {
        method: "POST",
        body: formData,
      });
      const data = await res.json();
      return data;
    } catch (err) {
      console.error('Upload error:', err);
      return null;
    }
  }

  const capture = useCallback(async () => {
    setIsCapturing(true);
    
    // Add capture animation delay
    setTimeout(() => {
      const imageSrc = webcamRef.current.getScreenshot();
      setCapturedImage(imageSrc);
      
      setIsCapturing(false);
    }, 200);
  }, [webcamRef]);

  const closeModal = () => {
    setModal(false);
    setCapturedImage(null);
  };

  const confirmPhoto = async () => {
    if (onChange && capturedImage) {
      const file = base64ToFile(capturedImage, "image.png", "image/png");
      const uploadImage = await postStorageServer(file);
      if(uploadImage.status){
        onChange(uploadImage.data.url);
        closeModal();
      }else{
        Component.AlertError({ title: 'Error', text: "Take picture failed" })
      }
    }
  };

  return (
    <div style={{ position: 'relative', marginTop: 10 }}>
      {/* Trigger Button */}
      {
        image ? (
          <img src={image} alt="image" style={{width:"100%", height: 300, objectFit:"contain"}} />
        ) : (
          <img src={"https://jkfenner.com/wp-content/uploads/2019/11/default.jpg"} alt="image" style={{width:"100%", height: 300, objectFit:"contain"}}/>
        )
      }

      <div className="text-center mt-3">
        <button 
          onClick={() => setModal(true)}
          style={{
            background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
            border: 'none',
            borderRadius: '50px',
            padding: '12px 24px',
            color: 'white',
            fontSize: '16px',
            fontWeight: '500',
            cursor: 'pointer',
            boxShadow: '0 4px 15px rgba(102, 126, 234, 0.3)',
            transition: 'all 0.3s ease'
          }}
          onMouseOver={(e) => e.target.style.transform = 'translateY(-2px)'}
          onMouseOut={(e) => e.target.style.transform = 'translateY(0)'}
        >
          📸 Ambil Gambar
        </button>
      </div>

      {/* Camera Modal */}
      {modal && (
        <div style={{
          position: 'fixed',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          zIndex: 9999,
          backgroundColor: '#000',
          display: 'flex',
          flexDirection: 'column'
        }}>
          {/* Header */}
          <div style={{
            position: 'absolute',
            top: 0,
            left: 0,
            right: 0,
            height: '60px',
            background: 'linear-gradient(180deg, rgba(0,0,0,0.8) 0%, transparent 100%)',
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            padding: '10px 20px',
            zIndex: 10
          }}>
            <button 
              onClick={closeModal}
              style={{
                background: 'rgba(255,255,255,0.2)',
                border: 'none',
                borderRadius: '50%',
                width: '40px',
                height: '40px',
                color: 'white',
                fontSize: '20px',
                cursor: 'pointer',
                backdropFilter: 'blur(10px)'
              }}
            >
              ✕
            </button>
          </div>

          {/* Camera View */}
          <div style={{
            flex: 1,
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            position: 'relative',
            overflow: 'hidden'
          }}>
            {!capturedImage ? (
              <>
                <Webcam
                  audio={false}
                  ref={webcamRef}
                  screenshotFormat="image/jpeg"
                  videoConstraints={videoConstraints}
                  style={{
                    width: '100%',
                    height: '100%',
                    objectFit: 'cover'
                  }}
                />
                
                {/* Capture Flash Effect */}
                {isCapturing && (
                  <div style={{
                    position: 'absolute',
                    top: 0,
                    left: 0,
                    right: 0,
                    bottom: 0,
                    backgroundColor: 'white',
                    animation: 'flash 0.2s ease-out',
                    zIndex: 5
                  }} />
                )}
              </>
            ) : (
              // Captured Image Preview
              <img 
                src={capturedImage} 
                alt="Captured"
                style={{
                  width: '100%',
                  height: '100%',
                  objectFit: 'cover'
                }}
              />
            )}
          </div>

          {/* Bottom Controls */}
          <div style={{
            position: 'absolute',
            bottom: 0,
            left: 0,
            right: 0,
            height: '120px',
            background: 'linear-gradient(0deg, rgba(0,0,0,0.8) 0%, transparent 100%)',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            gap: '30px',
            padding: '20px'
          }}>
            {!capturedImage ? (
              <>
                {/* Switch Camera */}
                <button 
                  onClick={switchCamera}
                  style={{
                    background: 'rgba(255,255,255,0.2)',
                    border: '2px solid rgba(255,255,255,0.3)',
                    borderRadius: '15px',
                    width: '50px',
                    height: '50px',
                    color: 'white',
                    fontSize: '20px',
                    cursor: 'pointer',
                    backdropFilter: 'blur(10px)'
                  }}>
                  🔄
                </button>

                {/* Capture Button */}
                <button 
                  onClick={capture}
                  disabled={isCapturing}
                  style={{
                    background: isCapturing ? '#666' : 'white',
                    border: '4px solid rgba(255,255,255,0.3)',
                    borderRadius: '50%',
                    width: '80px',
                    height: '80px',
                    cursor: isCapturing ? 'not-allowed' : 'pointer',
                    transition: 'all 0.2s ease',
                    position: 'relative',
                    overflow: 'hidden'
                  }}
                >
                  <div style={{
                    width: '60px',
                    height: '60px',
                    borderRadius: '50%',
                    backgroundColor: isCapturing ? '#999' : '#007AFF',
                    margin: 'auto',
                    transition: 'all 0.2s ease'
                  }} />
                </button>

                <div style={{ width: '50px' }}/>
              </>
            ) : (
              <>

                {/* Confirm Button */}
                <button 
                  onClick={confirmPhoto}
                  style={{
                    background: '#00ff41',
                    border: 'none',
                    borderRadius: '25px',
                    padding: '12px 24px',
                    color: '#000',
                    fontSize: '16px',
                    fontWeight: '600',
                    cursor: 'pointer'
                  }}
                >
                  ✓ Gunakan Foto
                </button>
              </>
            )}
          </div>
        </div>
      )}

      {/* CSS Animations */}
      <style jsx>{`
        @keyframes flash {
          0% { opacity: 0; }
          50% { opacity: 0.8; }
          100% { opacity: 0; }
        }
        
        @keyframes pulse {
          0% { transform: scale(1); }
          50% { transform: scale(1.05); }
          100% { transform: scale(1); }
        }
      `}</style>
    </div>
  );
};

export default CameraComponent;